
import { Box } from "@material-ui/core"
import { Grid } from "@mui/material";
import InputDocUpload from "../../../../../../utils/inputFileUpload/inputDocUpload";


export default function DocsMedicamentosControladosInternacionalmenteAnexo({ HandleChangeFile }) {

    return (
        <Box>
            <Grid container>
                <Grid xs={12} md item m>
                    <InputDocUpload
                        onFileSelect={HandleChangeFile}
                        inputName={'faturaFinal'}
                        inputDescription={'Factura final'}
                        inputTitle={'Factura final'}
                    />
                </Grid>

                <Grid xs={12} md item m>
                    <InputDocUpload
                        onFileSelect={HandleChangeFile}
                        inputName={'faturaEmolumento'}
                        inputDescription={'Factura de pagamento de emolumento na Armed'}
                        inputTitle={'Factura de pagamento de emolumento na Armed'}
                    />
                </Grid>
            </Grid>

            <Grid container>
                <Grid xs={12} md item m>
                    <InputDocUpload
                        onFileSelect={HandleChangeFile}
                        inputName={'cartaPorteBl'}
                        inputDescription={'Carta de porte'}
                        inputTitle={'Carta de porte'}
                    />
                </Grid>

                <Grid xs={12} md item m>
                    <InputDocUpload
                        onFileSelect={HandleChangeFile}
                        inputName={'certificadoOP'}
                        inputDescription={'Certificado de origem'}
                        inputTitle={'Certificado de origem'}
                    />
                </Grid>
            </Grid>

            <Grid container>
                <Grid xs={12} md item m>
                    <InputDocUpload
                        onFileSelect={HandleChangeFile}
                        inputName={'CertificadoAnaliticoLote'}
                        inputDescription={'Certificado análitico por lote'}
                        inputTitle={'Certificado análitico por lote'}
                    />

                </Grid>

                <Grid xs={12} md item m>
                    <InputDocUpload
                        onFileSelect={HandleChangeFile}
                        inputName={'certificadoExportacao'}
                        inputDescription={'Certificado de exportação'}
                        inputTitle={'Certificado de exportação'}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}


